<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.nickname" placeholder="请输入用户昵称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="videoUrl" label="视频URL" width="182">
                <template slot-scope="scope">
                    <img :src="extendUrl + scope.row.videoImage" style="width: 160px; height: 90px; cursor: pointer;" @click="videoOpen(scope.row)"></img>
                </template>
            </el-table-column>
            <el-table-column prop="enhanceName" label="增强名称"></el-table-column>
            <el-table-column prop="enhanceModeName" label="模型" width="110"></el-table-column>
            <el-table-column prop="enhanceResolutionName" label="分辨率" width="110"></el-table-column>
            <el-table-column prop="status" label="状态" width="80">+
                <template slot-scope="scope">
                    {{ getStatusName(scope.row.enhanceStatus) }}
                </template>
            </el-table-column>
            <el-table-column prop="enhanceDuration" label="时长" width="70">
                <template slot-scope="scope">
                    {{ scope.row.enhanceDuration.toFixed(0) }}s
                </template>
            </el-table-column>
            <el-table-column prop="enhanceFps" label="FPS" width="70"></el-table-column>
            <el-table-column prop="enhancePackagePoint" label="花费" width="70"></el-table-column>
            <el-table-column prop="enhanceSdkTask" label="任务ID" width="290"></el-table-column>
            <el-table-column prop="enhanceDate" label="创建日期" width="160">
                <template slot-scope="scope">
                    {{ getFormatDate(scope.row.enhanceDate * 1000) }}
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="视频播放" :visible.sync="isVideo" width="60%" :close-on-click-modal="true">
            <video :src="extendUrl + videoUrl" style="width: 100%;" controls></video>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            isVideo: false,
            videoUrl: "",
            statusArray: [
                { value: 0, label: '等待处理' },
                { value: 1, label: '增强中' },
                { value: 2, label: '已完成' },
                { value: 3, label: '处理失败' },
            ]
        }
    },
    methods: {
        getStatusName: function(status) {
            for (let i = 0; i < this.statusArray.length; i++) {
                if (this.statusArray[i].value == status) {
                    return this.statusArray[i].label;
                }
            }
            return "";
        },
        videoOpen: function(row) {
            this.videoUrl = row.videoSrc;
            this.isVideo = true;
        },
        getData: async function() {
            this.initialData();
        }
    },
    created: function () {
        this.tag = "ENHANCE";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>